import React, { useState } from "react";
import Noimage from "../../images/contact/Kareem Arabian Company Biulding - try1 2024-11-07 (2).jpg";
import axios from "axios";

const GetInTouch = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    userType: "",
    industry: "",
    requestType: "",
    country: "",
    email: "",
    phone: "",
    comments: "",
    marketing: false,
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [bgColor, setBgColor] = useState("transparent");
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let newErrors = {};
    Object.keys(formData).forEach((field) => {
      if (!formData[field] && field !== "marketing") {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setTimeout(async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          setErrors({ general: "Authentication token missing. Please login again." });
          setLoading(false);
          return;
        }

        // Map frontend keys to backend expected keys
        const payload = {
          name: formData.fullName,
          usertype: formData.userType,
          industry: formData.industry,
          requestType: formData.requestType,
          country: formData.country,
          email: formData.email,
          phonenumber: formData.phone,
          message: formData.comments,
        };

        const response = await axios.post(
          "https://backend.aktcorp.com/user/contact",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          setSuccessMessage("Your message has been sent successfully!");
          setTimeout(() => setSuccessMessage(""), 5000);
          setFormData({
            fullName: "",
            userType: "",
            industry: "",
            requestType: "",
            country: "",
            email: "",
            phone: "",
            comments: "",
            marketing: false,
          });
          setErrors({});
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setErrors({ general: "Failed to send message. Please try again later." });
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#0c2341] p-1 md:!p-2 mb-2">
      <div className="flex flex-col lg:flex-row w-full gap-3 h-auto lg:h-[90vh]">
        <div className="w-full lg:w-8/12  rounded-lg group">
          <img
            src={Noimage}
            alt="Warehouse"
            className="w-full h-full object-contain rounded-lg transition-transform duration-500 "
          />
        </div>

        <div className="w-full lg:w-4/12 bg-white p-6 md:p-8 shadow-lg rounded-lg flex flex-col justify-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Get in Touch with Us
          </h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            Have questions or need product details? Fill out the form below, and one of our
            representatives will reach out to you promptly.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="text"
                placeholder="Full Name"
                className="w-full p-3 border border-gray-300 rounded-md"
                value={formData.fullName}
                onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                required
              />
              {errors.fullName && <p className="text-red-500 ml-1 text-sm">*{errors.fullName}</p>}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <select
                  className="w-full p-3 border border-gray-300 rounded-md"
                  value={formData.userType}
                  onChange={(e) => setFormData({ ...formData, userType: e.target.value })}
                >
                  <option value="">I am...</option>
                  <option value="Individual">Individual</option>
                  <option value="Business">Business</option>
                </select>
                {errors.userType && <p className="text-red-500 ml-1 text-sm">*{errors.userType}</p>}
              </div>
              <div>
                <select
                  className="w-full p-3 border border-gray-300 rounded-md"
                  value={formData.industry}
                  onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
                >
                  <option value="">Industry</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Retail">Retail</option>
                </select>
                {errors.industry && <p className="text-red-500 ml-1 text-sm">*{errors.industry}</p>}
              </div>

              <div>
                <select
                  className="w-full p-3 border border-gray-300 rounded-md"
                  value={formData.requestType}
                  onChange={(e) => setFormData({ ...formData, requestType: e.target.value })}
                >
                  <option value="">Request Type</option>
                  <option value="Product Inquiry">Product Inquiry</option>
                  <option value="Support">Support</option>
                </select>
                {errors.requestType && <p className="text-red-500 ml-1 text-sm">*{errors.requestType}</p>}
              </div>

              <div>
                <select
                  className="w-full p-3 border border-gray-300 rounded-md"
                  value={formData.country}
                  onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                >
                  <option value="">Select Country</option>
                  <option value="USA">USA</option>
                  <option value="India">India</option>
                </select>
                {errors.country && <p className="text-red-500 ml-1 text-sm">*{errors.country}</p>}
              </div>
            </div>
            <div>
              <input
                type="email"
                placeholder="Email"
                className="w-full p-3 border border-gray-300 rounded-md"
                value={formData.email}
                onChange={(e) => {
                  setFormData({ ...formData, email: e.target.value });

                  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailPattern.test(e.target.value)) {
                    setErrors((prevErrors) => ({ ...prevErrors, email: "Invalid email format" }));
                  } else {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.email;
                      return newErrors;
                    });
                  }
                }}
              />
              {errors.email && <p className="text-red-500 ml-1 text-sm">*{errors.email}</p>}
            </div>

            <div>
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full p-3 border border-gray-300 rounded-md"
                value={formData.phone}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/\D/g, "");
                  setFormData({ ...formData, phone: inputValue });

                  if (!/^\d{10}$/.test(inputValue)) {
                    setErrors((prevErrors) => ({ ...prevErrors, phone: "Enter a valid 10-digit mobile number" }));
                  } else {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.phone;
                      return newErrors;
                    });
                  }
                }}
                maxLength={10}
              />
              {errors.phone && <p className="text-red-500 ml-1 text-sm">*{errors.phone}</p>}
            </div>

            <textarea
              placeholder="Comments"
              className="w-full p-3 border border-gray-300 rounded-md"
              rows="3"
              value={formData.comments}
              onChange={(e) => setFormData({ ...formData, comments: e.target.value })}
            ></textarea>
            {errors.comments && <p className="text-red-500 ml-1 text-sm">*{errors.comments}</p>}

            <button
              type="submit"
              className="px-3 py-2 border-2 border-[#0C2340] text-[#0C2340] hover:text-white w-full font-semibold rounded-lg transition duration-300"
              style={{ backgroundColor: bgColor }}
              onMouseEnter={() => setBgColor("#1B365D")}
              onMouseLeave={() => setBgColor("white")}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="w-6 h-6 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                "SUBMIT"
              )}
            </button>

            {errors.general && (
              <div className="text-red-600 text-center mt-2">{errors.general}</div>
            )}

            {successMessage && (
              <div className="text-green-600 text-xl mt-2 text-center">
                {successMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
